import { Point } from "../../graphicLibs/index";
import { PointInfo } from "../../WalltoFittingInfo";
import { CreatePointData } from "../CreatePointData";

/** 
 * なす角が小さい部屋の削除
 * */
export class SmallAngleRoomDelete {

    private threthord: number = 0;

    constructor(public pointList: PointInfo[]) {
    }

    public execute() {

        const getNextIndex = (array: number[], i: number, count: number): number => {
            const index = array[(i + count) % array.length];
            if (this.pointList[index].isDelete == false) return (i + count) % array.length;
            let k = 0;
            for (let j = i + count + 1; k < array.length; j++) {
                if (this.pointList[array[j % array.length]].isDelete == false) return j % array.length;
                k+=1;
            }
            
        }

        const pointData = new CreatePointData(this.pointList);
        pointData.execute();
        const roomList = pointData.roomList;

        // const rad10 = 0.174533; // 10度の時のラジアン
        // const rad30 = 0.523599; // 30度の時のラジアン

        roomList.forEach((indexes: number[], j: number) => {
            let isDelete = false;
            indexes.forEach((index: number, i: number, array: number[]) => {
                const index2 = getNextIndex(indexes, i, 1);
                const index3 = getNextIndex(indexes, i, 2);
                
                const p1 = this.pointList[index].point;
                const p2 = this.pointList[array[index2]].point;
                const p3 = this.pointList[array[index3]].point;

                const vec1 = p1.clone().sub(p2);
                const vec2 = p3.clone().sub(p2);

                const rad = vec1.clone().angleTo(vec2);
                const cos = vec1.clone().dot(vec2);
                console.log('rad', rad);
                
                // なす角が10度未満
                if (0 < rad && rad < this.threthord && 0 < cos) {
                    isDelete = true;
                }
            });

            if (isDelete) {
                indexes.forEach((index: number) => {
                    for (let k = 0; k < roomList.length; k++) {
                        if (k == j) continue;
                        if (roomList[k].includes(Point.nextPoint(index))) return;
                    }
                    this.pointList[index].isDelete = true;
                    this.pointList[Point.nextPoint(index)].isDelete = true;
                });
            }
        });

        return this.pointList;

    }

    public length(degree: number) {
        this.threthord = degree * ( Math.PI / 180 );
    }

}